"use strict";
/*
 * Created on 07 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AsyncOperationResultList_1 = require("../AsyncOperationResultList");

var ResultListConverter_1 = require("./ResultListConverter");
/**
 * Implementation of {@link ResultListConverter} for {@link AsyncOperationResultList}.
 *
 * @author JMe
 */


var AsyncOperationResultListConverterImpl =
/*#__PURE__*/
function (_ResultListConverter_) {
  _inherits(AsyncOperationResultListConverterImpl, _ResultListConverter_);

  function AsyncOperationResultListConverterImpl(itemConverter) {
    var _this;

    _classCallCheck(this, AsyncOperationResultListConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AsyncOperationResultListConverterImpl).call(this));
    _this.itemConverter = itemConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AsyncOperationResultListConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new AsyncOperationResultList_1.AsyncOperationResultList(conversions.asObjectOpt(source, 'monitorId', function (v) {
        return conversions.toClassReferenceId(v);
      }), conversions.asObjectList(source, 'result', function (doc) {
        return _this2.itemConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, {
        monitorId: source.monitorId ? conversions.toDocumentReferenceId(source.monitorId) : null,
        result: source.result != null ? conversions.asObjectArray(source, 'result', function (item) {
          return _this3.itemConverter.toDocument(item, conversions);
        }) : []
      });
      return document;
    }
  }]);

  return AsyncOperationResultListConverterImpl;
}(ResultListConverter_1.ResultListConverter);

exports.AsyncOperationResultListConverterImpl = AsyncOperationResultListConverterImpl;